import axios from "axios";
import { browserHistory } from "react-router";

export function loginRequest(username, password) {
  return function (dispatch) {
    axios.defaults.headers.Authorization = false;
    axios
      .post("/v1/auth/login/", {
        username,
        password
      })
      .then((response) => {
        if (response.data.token && response.data.user.is_instructor) {
          localStorage.clear();
          localStorage.onboarding_state = response.data.user.onboarding_state;
          localStorage.loginToken = response.data.token;
          localStorage.userUUID = response.data.user.uuid;
          localStorage.userName = response.data.user.full_name;
          localStorage.userFirstName = response.data.user.first_name || response.data.user.initials;

          axios.defaults.headers.Authorization = "Token " + localStorage.loginToken;

          dispatch({
            type: "LOGIN_SUCCESS",
            loginToken: response.data.token
          });

          if (response.data.user.onboarding_state !== APP_CONFIG.onboarding_state) {
            // Privacy statement is not accepted, forward the user to the privacy statement
            browserHistory.push("/intro");
          } else {
            browserHistory.push("/events");
          }
        } else {
          localStorage.loginToken = "invalid";
          dispatch({
            type: "LOGIN_ERROR",
            loginToken: "invalid"
          });
        }
      })
      .catch(function (err) {
        localStorage.loginToken = "invalid";
        dispatch({
          type: "LOGIN_ERROR",
          loginToken: "invalid"
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/authentication.js